import { Wrapper } from 'AppReact';
import styled from 'styled-components';

export default Wrapper(styled.div`display: flex; gap: 1.25rem; flex-wrap: wrap;`)
